<template>
    <div class="headerLink">
        <div class="container clearfix">
            <div class="fl" v-text="title">Hi，欢迎来到数据智能服务平台</div>
            <div class="fr clearfix">
                <div class="hLink fl">
                    <ul>
                        <li><a href="#" @click="gotoEnterprise()">企业中心</a></li>
                        <li v-if="sysManage"><a href="#" @click="gotoManage()">管理后台</a></li>
                    </ul>
                </div>
                <div class="regLogin fr">
                    <!-- 登录后隐藏 注册 登录 按钮-->
                    <!--<a class="regBtn" :href="loginUrl + '?page=reg'" v-if="!userId">快速注册</a>-->
                    <a class="logiBtn bgBtn" :href="loginUrl" v-if="!loginFlag">注册<span>/</span>登录</a>
                    <div class="loginMsg" v-if="loginFlag">
                        <div class="name">
                            <!--<span class="uImg">-->
                                <!--<img :src="avatar" v-if="avatar">-->
                                <!--<img src="@/pages/frontend/assets/images/defaultHeadIcons.png" v-else>-->
                            <!--</span>-->
                            {{username}}<i class="icons-down"></i>
                        </div>
                        <div class="subMenu">
                            <div class="menuList">
                                <router-link to="/userPortrait"><a
                                        href="#">个人中心</a></router-link>
                                <a href="#" @click="handleUserSecurity">账号安全</a>
                                <a href="#" @click="logout">退出登录</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--封禁弹窗-->
        <el-dialog title="企业已封禁" :visible.sync="entBanDialog" width="500px" append-to-body>
            <span>抱歉，所属的企业因违规操作已被封禁，您无法进入企业中心</span><br>
            <span>如需帮助，请致电：400-684-0020</span>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="entBanDialog = false">确 定</el-button>
                <el-button @click="entBanDialog = false">取 消</el-button>
            </div>
        </el-dialog>
        <EntCheckDialog></EntCheckDialog>
    </div>
</template>
<script>
    import {getInfoById} from '@/api/enterprise'
    import {
        checkSysManage,
        getEnterpriseAdmin,
        getLoginUserInfo,
        getLoginUserPermissions,
        logout,
        securityPath
    } from '@/api/user'
    import {EntCheckDialog} from '@/pages/frontend/components';


    export default {
        data() {
            return {
                title: "", //
                loginUrl: '/login', // 登录url路径
                registerUrl: '', // 注册url路径
                userId: '', // 用户Id
                username: '', //用户名
                avatar: '', // 用户头像
                loginFlag: false, //用户是否已登陆
                enterpriseId: undefined,
                sysManage: false,
                entBanDialog: false,// 企业已被封禁弹窗
            };
        },
        created: function () {
            if (this.Cookies.get('APP_HEADER_NAME')) {
                this.title = "Hi，欢迎来到" + decodeURI(this.Cookies.get('APP_HEADER_NAME'));
            }
            setTimeout(() => {
                this.getRegisterUrl();
                this.getLoginFlag(); //检测用户是否登陆
                this.getLoginUserInfoFromLocalStorage();
            }, 500);
        },
        methods: {
            handleUserSecurity() {
                window.open(securityPath, "_blank");
            },
            /** 退出登录，清除localStorage*/
            logout() {
                logout().then(res => {
                    if (res && res.status && res.status == 200) {
                        window.localStorage.clear();
                        if (process.env.NODE_ENV == "development") {
                            let uri = window.location.origin;
                            window.location.href = uri + "/frontend#/index";
                        } else {
                            window.location.href = res.data;
                        }
                    }
                })
            },
            /** 判断用户是否登陆*/
            getLoginFlag() {
                if (this.Cookies.get("TipDM-Login-Token")) {
                    this.loginFlag = true;
                    this.getLoginUserInfo(); //获取登陆用户信息
                    this.checkSysManage();
                } else {
                    window.localStorage.clear();
                }
            },
            /** 从cookie获取注册地址*/
            getRegisterUrl() {
                this.registerUrl = this.Cookies.get("REGISTER_URL");
            },
            getLoginUserInfoFromLocalStorage() {
                this.userId = window.localStorage.getItem("userId");
                this.enterpriseId = window.localStorage.getItem("enterpriseId");
                this.username = window.localStorage.getItem("username");
                this.avatar = window.localStorage.getItem("avatar");
            },
            getLoginUserInfo() {
                if (!window.localStorage) {
                    this.msgError("浏览器不支持localStorage");
                    return false;
                } else {
                    let storage = window.localStorage;
                    let userInfo = storage.getItem("loginUserInfo");
                    if (!userInfo) {
                        getLoginUserInfo().then(res => {
                            if (res && res.data && res.data.userId) {
                                this.checkSysManage();
                                if (!window.localStorage.getItem("enterpriseId")) {
                                    this.getEnterpriseAdmin();
                                }
                            }
                            // 获取用户权限
                            getLoginUserPermissions().then(permissionsRes => {
                                res.data.permissions = permissionsRes.data;
                                storage.setItem("loginUserInfo", JSON.stringify(res.data));
                            });
                            storage.setItem("userId", res.data.userId);
                            storage.setItem("username", res.data.username);

                            if (res.data.avatar != null) {
                                storage.setItem("avatar", res.data.avatar);
                            }
                            this.getLoginUserInfoFromLocalStorage();
                        })
                    }
                }
            },
            getEnterpriseAdmin() {
                getEnterpriseAdmin().then(res => {
                    if (!window.localStorage) {
                        this.msgError("浏览器不支持localStorage")
                        return false;
                    } else {
                        let storage = window.localStorage;
                        if (res && res.data) {
                            this.enterpriseId = res.data;
                            storage.setItem("enterpriseId", res.data);
                        }
                    }
                });
            },
            // 判断是否有管理员权限
            checkSysManage() {
                checkSysManage().then(res => {
                    if (res && res.status == 200) {
                        this.sysManage = res.data
                    }
                });
            },
            gotoEnterprise() {
                this.$store.commit('gotoEnterprise', {
                    check: true,
                    targetUri: '/backend#/index'
                });
            },
            // 到管理后台
            gotoManage() {
                window.open(window.location.origin + "/backend#/index");
            }
        },
        components: {
            EntCheckDialog,
        }
    }
</script>
